export default "__VITE_ASSET__COm__jf9__"